import { Injectable, Type } from '@angular/core';
import {
  CplaceBooleanControlComponent,
  CplaceControlComponent,
  CplaceSingleIconControlComponent,
  CplaceSingleLocalizedTextControlComponent,
  CplaceSingleNumberControlComponent,
  CplaceSingleReferenceControlComponent,
  CplaceSingleSelectControlComponent,
  CplaceSingleTextControlComponent,
} from '../components';
import { CfControlPlugin } from './cf-control-plugin';
import { CplaceBooleanControlPlugin } from './cplace-boolean-control.plugin';
import { CplaceSingleIconControlPlugin } from './cplace-single-icon-control.plugin';
import { CplaceSingleLocalizedTextControlPlugin } from './cplace-single-localized-text-control.plugin';
import { CplaceSingleNumberControlPlugin } from './cplace-single-number-control.plugin';
import { CplaceSingleReferenceControlPlugin } from './cplace-single-reference-control.plugin';
import { CplaceSingleSelectControlPlugin } from './cplace-single-select-control.plugin';
import { CplaceSingleTextControlPlugin } from './cplace-single-text-control.plugin';

@Injectable({ providedIn: 'root' })
export class CfControlPluginService {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private pluginRegistry: { [key: string]: Type<CfControlPlugin<any>> } = {};

  constructor() {
    this.register(CplaceSingleTextControlComponent.componentName, CplaceSingleTextControlPlugin);
    this.register(CplaceSingleSelectControlComponent.componentName, CplaceSingleSelectControlPlugin);
    this.register(CplaceSingleIconControlComponent.componentName, CplaceSingleIconControlPlugin);
    this.register(CplaceSingleLocalizedTextControlComponent.componentName, CplaceSingleLocalizedTextControlPlugin);
    this.register(CplaceSingleNumberControlComponent.componentName, CplaceSingleNumberControlPlugin);
    this.register(CplaceBooleanControlComponent.componentName, CplaceBooleanControlPlugin);
    this.register(CplaceSingleReferenceControlComponent.componentName, CplaceSingleReferenceControlPlugin);
  }

  /**
   * Registers the control plugin
   * @param type Control type
   * @param plugin Plugin class
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public register<T extends CplaceControlComponent<any>>(type: string, plugin: new () => CfControlPlugin<T>): void {
    this.pluginRegistry[type] = plugin;
  }

  /**
   * Initializes the matching plugin by the given control type
   * @param type Control type
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public initPluginByType<T extends CplaceControlComponent<any>>(type: string): CfControlPlugin<T> | undefined {
    const plugin = this.getPluginByType<T>(type);
    return plugin ? new plugin() : undefined;
  }

  /**
   * Gets the matching plugin from the plugin registry
   * @param type Control type
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public getPluginByType<V extends CplaceControlComponent<any>>(type: string): Type<CfControlPlugin<V>> | undefined {
    return this.pluginRegistry[type];
  }
}
